// ==========================================
// src/components/sections/TeamSection.js
// ==========================================
import React from 'react';
import SectionHeader from '../common/SectionHeader';

const TeamSection = () => {
  return (
    <section id="team" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title="Our Team"
          subtitle="Operators, engineers, and builders who've lived the problems we solve"
        />

        <div className="max-w-4xl mx-auto space-y-8">
          {/* Team Context */}
          <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 shadow-lg">
            <p className="text-gray-600 leading-relaxed text-center max-w-3xl mx-auto">
                Our team has been in the trenches—managing live freight operations, 
                building enterprise software under pressure, and solving real problems for companies moving serious volume. 
                We've worked midnight dispatches, debugged critical systems at 3 AM, and optimized supply chains 
                handling millions in freight.  <span className="font-medium text-gray-900"> We know this industry because we've lived it.</span>
            </p>
          </div>

          {/* Stats Grid */}
          <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-2xl p-8 shadow-lg">
            <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">Collective Experience</h3>
            
            <div className="grid md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">15+</div>
                <p className="text-gray-600 font-medium mb-1">Years in Logistics</p>
                <p className="text-sm text-gray-500">From dispatch to 3PL operations to warehouse management</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">20+</div>
                <p className="text-gray-600 font-medium mb-1">Years Building Software</p>
                <p className="text-sm text-gray-500">Enterprise platforms, APIs, and scalable systems</p>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-2">35+</div>
                <p className="text-gray-600 font-medium mb-1">Years of Technical Expertise</p>
                <p className="text-sm text-gray-500">From naval engineering to SaaS and cloud infrastructure</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;